module.exports = __webpack_public_path__ + "staticVue/img/cts-logo-white.3db98769.png";